<template>
  <div class="c-input-group-text" v-bind="$attrs" v-on="$listeners">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'BaseInputGroupText'
  }
</script>
